import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 sm:gap-4" }
const _hoisted_2 = { class: "w-fit bg-yellow-400 rounded-xl py-1 px-2 m-auto flex items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-600 font-bold" }, "Filter Favorite", -1)
const _hoisted_4 = { class: "text-white mt-1" }

import ArtPlayer from 'artplayer';
import axios from 'axios';
import { nextTick, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import { File } from '@/model/document';
import { getDocumentDetail } from '@/repository/document';
import { Switch } from 'ant-design-vue';
import { StarFilled } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaView',
  props: {
    redirectURL: {},
    documentUUID: {}
  },
  setup(__props: any) {

const props = __props;



const route = useRoute();
const router = useRouter();
const files = ref<File[]>([]);
const filesView = ref<File[]>([]);
const isFavorite = ref(route.query.isFavorite === 'true' || false);
const reload = ref(false);

onMounted(init);

watch(files, setFilesView);
watch(isFavorite, () => {
	setFilesView();
	router.replace({ query: { ...route.query, isFavorite: isFavorite.value ? 'true' : undefined } });
});

async function setFilesView() {
	reload.value = true;
	await new Promise((resolve) => setTimeout(resolve, 10)); // Wait for DOM update
	filesView.value = [...files.value.filter((file) => (isFavorite.value ? file.isFavorite : true))];
	reload.value = false;
}

async function init() {
	const res = await getDocumentDetail(props.documentUUID);
	if (res) {
		files.value = res.files;
		return streamVideoFile(files.value);
	}
	await router.push(props.redirectURL);
}

async function streamVideoFile(files: File[]) {
	const isMediaFound = files.findIndex((file) => file.mimeType.startsWith('video/')) !== -1;
	if (!isMediaFound) {
		return;
	}

	const arts = new Array<ArtPlayer>(files.length);
	nextTick(() =>
		files.forEach(async (file, index) => {
			if (file.mimeType.startsWith('video/')) {
				arts[index] = setupVideoStreaming(`.video-onlyfans-${index}`, '', file.thumbnailURL);
				try {
					const res = await axios.request<Blob>({
						url: file.originalURL,
						responseType: 'blob'
					});
					arts[index].url = URL.createObjectURL(res.data);
				} catch (error) {
					console.error(error);
				}
			}
		})
	);
}

function setupVideoStreaming(container: string, url: string, thumbnailURL: string) {
	return new ArtPlayer({
		container,
		url,
		theme: '#23ade5',
		muted: true,
		setting: true,
		playbackRate: true,
		aspectRatio: true,
		fullscreen: true,
		fullscreenWeb: true,
		subtitleOffset: true,
		miniProgressBar: true,
		mutex: true,
		backdrop: true,
		playsInline: true,
		autoPlayback: true,
		airplay: true,
		lang: navigator.language.toLowerCase(),
		moreVideoAttr: {
			crossOrigin: 'anonymous'
		},
		thumbnails: {
			url: thumbnailURL,
			number: 60,
			column: 10
		}
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(Switch), {
        checked: isFavorite.value,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((isFavorite).value = $event))
      }, {
        checkedChildren: _withCtx(() => [
          _createVNode(_unref(StarFilled))
        ]),
        _: 1
      }, 8, ["checked"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesView.value, (file, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (file.mimeType.startsWith('image/'))
          ? (_openBlock(), _createBlock(ImageLoading, {
              key: 0,
              src: file.originalURL,
              previewable: true,
              reload: reload.value,
              isForceLoading: "",
              "img-class": "max-w-2xl !w-full",
              "loading-class": "max-w-2xl w-full h-full aspect-square m-auto"
            }, null, 8, ["src", "reload"]))
          : (file.mimeType.startsWith('video/'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(`video-onlyfans-${index} max-w-2xl max-h-[21rem] w-full h-[21rem] m-auto`)
              }, null, 2))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(index + 1) + " / " + _toDisplayString(filesView.value.length), 1)
      ]))
    }), 128))
  ]))
}
}

})